export default {
  message: {
    // 登录注册
    login:'로그인', // 登录
    register:'가입하기', // 注册
    cancel:'취소', // 取消
    confirm:'확인', // 确认
    loginSuccess:'로그인 성공.', // 登录成功
    loginFail:'로그인 실패.', // 登录失败
    loginFailed:'아이디 또는 비밀번호가 잘못되었습니다.',// 账号或密码错误！
    registerSuccess:'가입이 완료되었습니다.', // 注册完成
    registerFail:'가입에 실패했습니다.', // 注册失败
    requiredMessage:'작성해 주세요', // 请填写 영수증 다시 써 주세요
    requiredUserName:'아이디', // 用户名
    requiredPWD:'비밀번호', // 密码
    requiredPhone:'휴대폰 번호', // 手机号码
    requiredEmail:'회원 이메일', // 用户邮箱
    // 修改密码
    changePwd:'비밀번호 변경', // 修改密码
    requiredOldPWD:'기존 비밀번호', // 旧密码
    requiredNewPWD:'새 비밀번호', // 新密码
    requiredConfirmPWD:'비밀번호 확인', // 确认密码
    changePWDError1:'기존 비밀번호가 틀렸습니다.',// 旧密码错误
    changePWDError2:'새 비밀번호와 확인 비밀번호가 일치하지 않습니다. 다시 입력해 주세요.',// 新密码前后不一致，请重新填写
    changePWDSuccess:'비밀번호가 성공적으로 변경되었습니다.',// 密码更新成功
    requestError:'요청 매개변수 오류.',// 请求参数错误
    logoutSuccess:'로그아웃되었습니다.',// 退出登录成功
    logout:'로그아웃',// 退出登录
    emailError:'올바른 이메일 주소를 입력해 주세요.',// 请输入正确的邮箱地址
    // 两个合并弹窗
    notRegister:'아직 계정이 없으신가요？ ',// 还未注册？
    hasAccount:'계정이 있으시면 로그인해 주세요！', // 已有账号就登录吧
    
    

    searchPlaceholder: '찾고 싶은 상품을 검색해보세요!',
    searchNull:'해당 상품을 못 찾았어요',// 没有查找到相关商品
    productTag1:"신속하게 화물을 발송하다",//迅速发货
    productTag2:"안전하게 배달하다",//安全送达
    cart: "장바구니",
    home: "본문",
    discountText: "최다 60%할인 가능",
    headingTitle: "신제품",
    addToCart: "장바구니 추가",
    price: "가격",
    rate: "평점",
    TotalPrice: "총액",
    //
    goodNum: "수량",
    buyNow: "지금 구매",
    addCart: "카트 추가",
    productDetailTitle: "상품 상세 정보",
    productRecommendationsTitle: "상품 추천",
    categoryTitle: "상품 분류",
    hotgoodstitle: "인기 상품",
    smallDetails: "본 상품은 인기 판매 중",
    orderSale: "판매",
    msgLanguage: "가입 성공",

    sort: "분류",
    clear: "모두 삭제",
    dialogTitle: "배송지 정보 입력",

    dialogGivenName: "성씨",
    dialogSurname: "이름",
    dialogPhone: "전화번호",
    dialogEmail: "이메일",
    dialogPostalCode: "우편번호",
    dialogAdminArea1: "광역시/도",
    dialogAdminArea2: "시/군/구",
    dialogAddressLine1: "읍/면/동",
    dialogAddressLine2: "스위트룸/아파트 번호",
    dialogDescription: "상품 정보",
    dialogValue: "가격",

    errorTips: "링크가 입력되지 않았습니다. 다시 결제해 주십시오.",
    errorTips2: "언어를 먼저 선택하십시오.",
    errorTips3: "버전 번호를 가져오지 못했습니다. 다시 결제하십시오.",
    notProductTitle: "제목없음",

    // 韩语另一个支付方法
    koDialogSubject: "상품명", //商品名称
    koDialogContent: "상품내용", //商品内容
    koDialogAmount: "금액", //金额
    koDialogUsername: "이름", //客户姓名
    dialogPayPhone: "전화번호", //电话号码
    dialogPayEmail: "이메일", //邮箱
    koDialogZipCode: "우편번호", //邮编
    koDialogUnit: "단위", //单位
    koDialogKRW: "원", //KRW 元

    paySelectTitle: "결제 수단을 선택하세요", //韩语下选择支付方式
    paySelectWay: "방식", //方式

    clipsPayUserX: "고객 성", //客户姓
    clipsPayUserM: "고객 이름", //客户名

    dialogPayErrorTip4: "정확한 우편함 주소를 입력해 주세요", // 请输入正确的邮箱地址

    // 支付弹窗 银行卡收款
    dialogPayBankCard: "은행카드 수금", // 银行卡收款
    dialogPayClientName: "고객 이름", // 客户姓名 ---银行卡收款
    dialogPayFullAddress: "고객 주소", // 客户地址 ---银行卡收款
    dialogPayBankName: "은행 명칭", // 银行名称 ---银行卡收款
    dialogPayCardNumber: "은행 카드 번호", // 银行卡号 ---银行卡收款
    dialogPayCardHolder: "카드 소지자", // 持卡人 ---银行卡收款
    dialogPaySubmit: "커밋에 성공했습니다", // 提交成功 ---银行卡收款
    dialogPayProductName: "상품명", // 商品名称 ---银行卡收款
    dialogPayProductAmount: "상품 금액", // 商品金额 ---银行卡收款

    /*旧版*/
    // dialogGivenName: "성씨",
    // dialogSurname: "이름",
    // dialogPhone: "전화번호",
    // dialogEmail: "이메일",
    // dialogPostalCode: "우편번호",
    // dialogAdminArea1: "도특별시/광역시",
    // dialogAdminArea2: "시/군/구",
    // dialogAddressLine1: "읍/면/동",
    // dialogAddressLine2: "스위트룸/아파트 번호",
    /*旧版*/

    dialogPay: "지불하러 가기",
    dialogClose: "닫기",
    delete: "삭제",
    formTips: "입력하십시오",
    selectPlaceholder: "선택하십시오",
    cartEmpty: "카트가 비어 있습니다.",
    detailSize: "사이즈",

    //
    buyItNow: "지금 사세요",
    shipping: "항공 수송",
    pay: "결제",
    back: "결제",
    support: "지원",
    shippingDesc: "심혈을 기울여 선별한 제품",
    checkOut: "결제하기",
    viewCart: "장바구니 조회하기",
    agreePrivacy: "저는 개인정보 및 정책에 동의합니다",
    remove: "삭제",
    total: "총계",
    language: "언어",

    // 联系我们字段
    openingHours: '영업시간', // 营业时间
    openingHoursText:'매주 오전 10시부터 오후 6시까지', //每周上午 10 点至下午 6 点
    contactEmail: '이메일', // 电子邮件
    companyName: '회사', // 公司
    companyAddress: '주소', // 地址
    contactPhone: '전화번호', // 电话号码
    principalName: '회사 주체',// 公司主体人
    principalName: '등록번호(CR)',// 公司注册号 (CR)
    principalName: '상업등록번호(BR)',// 公司商证号 (BR)

    
    aboutUsText: "어바웃 어스",
    // YouRui网站的
    aboutUsContent_yourui: `<div class="product__tab--content__step">
      <h2 class="product__tab--content__title">어바웃 어스</h2>
      <p>홍콩시방당국제건강관리유한회사 연구개발, 디자인, 생산, 마케팅, 홍보를 통합한 의류 기업입니다. 패션, 활력, 지성, 우아가 주류인 디자인 스타일로, 세련된 여성의 니즈에서 출발하여 디자인, 재료 선택, 커팅 및 디테일에 관계없이 일정한 높이를 유지합니다. 내포되어 있고 격식 있고 영적인 라이트 클래식 스타일을 손에 잡힐 수 있습니다.</p>
      <p>생활, 예술, 패션, 문화, 개성을 융합하여 소비자에게 고품질의 패션 생활 경험을 제공하기 위해 노력하고 있습니다. 항상 고객의 이익을 최우선으로 생각하고, 저희의 모든 고객에게 최고의 제품과 최고의 서비스를 제공하기 위해 최선을 다합니다.</p>
    </div>`,

    // ZhuoYu网站的
    aboutUsContent_zhuoyu: `<div class="product__tab--content__step">
      <h2 class="product__tab--content__title">어바웃 어스</h2>
      <p>탁유무역유한회사는 브랜드 홍보, 제품 개발 및 제조, 판매 서비스를 통합합니다. 회사는 우수한 마케팅 팀과 국내 각 구역 루트의 파트너를 보유하고 있으며 제품 시장 개발 및 제품 애프터서비스에 대한 건전한 관리 방안을 가지고 있습니다. </p>
      <p>판매 네트워크와 제품 판매 대리점이 전국에 퍼져 있음과 동시에 저희는 항상 '신뢰제일주의, 고객제일주의' 원칙을 고수하고 항상 고객의 이익을 최우선으로 생각하며 모든 고객에게 최고의 제품과 최상의 서비스를 제공합니다.</p>
    </div>`,

     // JieHeng网站的
     aboutUsContent_jieheng: `<div class="product__tab--content__step">
     <h2 class="product__tab--content__title">어바웃 어스</h2>
     <p>제항과학기술유한회사는 건강생활과 품질소비 분야에 전념하는 혁신형회사이다.우리는 전 세계 양질의 공급망 자원을 통합하고 탁월한 기능, 미학적 디자인 및 즐거운 경험을 겸비한 일상생활과 스포츠 건강 제품을 개발, 디자인 및 판매하는 데 주력하고 있습니다.</p>
     <p>회사는"매일 생활의 질감을 향상시키고 건강하고 활력 있는 인생을 부여한다"는 사명으로"향기로운 향기 제품","고성능 식수컵","요가 헬스"의 3대 핵심 제품 라인을 통해 현대 도시 사람들을 위해 자택 휴식에서 운동 단련에 이르는 전 장면 품질 생활 솔루션을 만든다.</p>
   </div>`,

    contactUsText: "저희와 연락하기",
    // YouRui网站的
    contactUsContent_yourui: `<div class="product__tab--content__step">
    <h2 class="product__tab--content__title">저희와 연락하기</h2>
      <p style="text-indent: 0em;">영업시간：매주 오전 10시부터 오후 6시까지</p>
      <p style="text-indent: 1em;">이메일：chloeannfountain691@gmail.com(국제 이메일 계좌 일시적으로 없음)</p>
      <p style="text-indent: 2em;">회사：홍콩시방당국제건강관리유한회사</p>
      <p style="text-indent: 1em;">kakao：akmalldjcod</p>
      <p style="text-indent: 2em;">주소：FLAT/RM B 5/F GAYLORD COMMERCIAL BUILDING 114-118 LOCKHART ROAD HK</p>
    </div>`,

    // ZhuoYu网站的
    contactUsContent_zhuoyu: `<div class="product__tab--content__step">
    <h2 class="product__tab--content__title">저희와 연락하기</h2>
      <p style="text-indent: 0em;">영업시간：매주 오전 10시부터 오후 6시까지</p>
      <p style="text-indent: 1em;">이메일：zhuoyu202403@gmail.com</p>
      <p style="text-indent: 2em;">회사：탁유무역유한회사Zhuoyu Trade Limited</p>
      <p style="text-indent: 1em;">kakao：akmalldjcod</p>
      <p style="text-indent: 2em;">주소：FLAT/RM 917A BLK A 9/F NEW MANDARIN PLAZA NO 14 SCIENCE MUSELM RD TST HONG KONG </p>
    </div>`,
    
    // JieHeng网站的
    contactUsContent_jieheng: `<div class="product__tab--content__step">
    <h2 class="product__tab--content__title">저희와 연락하기</h2>
      <p style="text-indent: 0em;">영업시간：매주 오전 10시부터 오후 6시까지</p>
      <p style="text-indent: 1em;">이메일：jieheng202403@gmail.com</p>
      <p style="text-indent: 2em;">회사：탁유무역유한회사Jieheng Trade Limited</p>
      <p style="text-indent: 1em;">kakao：akmalldjcod</p>
      <p style="text-indent: 2em;">주소：FLAT/RM 917A BLK A 9/F NEW MANDARIN PLAZA NO 14 SCIENCE MUSELM RD TST HONG KONG </p>
    </div>`,

    refundsText: "환불 및 제품 교환",
    refundsContent: `<div class="product__tab--content__step">
      <h2 class="product__tab--content__title">환불 및 제품 교환</h2>
      <p>고객님은 제품 받고 15일 이내에 환불 신청할 수 있습니다</p>
      <p>환불의 자격으로는 제품 미사용 및 제품 받을 당시 상태랑 같아야 합니다.원패키지 안에 담아져 있어야합니다.</p>
      <p>환불을 하려면 영수증 또는 구매증명이 필요합니다.</p>
      <p>구매하신 제품을 업체한테 보내지 마십시오.</p>
      <p>환불(해당되는 경우)</p>
      <p>저희가 환불 한 제품을 검사하고 환불 요청하신 제품을 받았다는 메일을 보낼거에요.그리고 환불 결재상황을 알려드릴게요.</p>
      <p>환불 신청이 통과되면 환불 처리 해드리겠습니다.그리고 며칠뒤 자동으로 결제에 사용하신 카드에 환불금액 입금될거에요.</p>
      <p>딜레이 혹은 환불금액 돌려받지 못할 경우(적합할 경우)</p>
      <p>아직 환불 받지 못하셨다면 다시 한번 은행 계좌를 확인하시기 바랍니다.</p>
      <p>그리고는 신용카드사에 연락하세요.당신의 환불은 일정한 시간이 지난 후 정식으로 발표될거에요.</p>
      <p>이 모든 작업을 완료했는데도 환불을 받지 못하셨다면 저희에게 연락 부탁드립니다.</p>
      <p>판매품목(해당되는 경우)</p>
      <p>정가 상품만 환불이 되는데 안타깝게도 프로모션 상품은 환불이 불가능합니다.</p>
      <p>거래소(해당되는 경우)</p>
      <p>저희는 결함이 있거나 손상된 물품만 교환합니다.같은 상품으로 교환을 원하시면 메일로 보내주시면 반품지 알려드리겠습니다.</p>
      <p>선물</p>
      <p>해당 상품을 구매 및 직접 배송 시 선물로 표시되었면 반품에 해당하는 기프트 포인트를 지급받으실 수 있습니다.반송된 물품 받으면 기프티콘 우편으로 보내드리겠습니다.</p>
      <p>만약 해당 상품이 구매 시 선물로 표기되지 않았거나, 선물한 사람이 주문 상품을 그들 자신에게 보내고 나중에 당신에게 보내준거라면, 우리는 선물한 사람에게 환불을 해줄 것이고, 그는 당신의 반품 상황을 알게 될 것입니다.</p>
      <p>항공 수송</p>
      <p>당신이 제품을 반품하려면, 먼저 우리에게 우편으로 보내서 상세한 정보를 얻어야 합니다.</p>
      <p>환불 정책:</p>
      <p>환불은 관련 수수료 공제</p>
      <p>한국 인천 서구 석남동 650-41 1동 2층.</p>
    </div>`,
    privacyText: "개인정보 정책",
    privacyContent: `
      <div class="product__tab--content__step">
        <h2 class="product__tab--content__title">개인정보 정책</h2>
        <p>어떤 방법으로 당신의 문자를 처리하는지?</p>
        <p>저희 스토어에서 제품 구매시 구매과정의 일부로써 당신이 제공한 개인정보, 예를 들어 이름,주소 및 메일을 수집할거에요.</p>
        <p>저희 스토어를 보고 계실때 당신의 웹 브라우저와 시스템 정보를 알기 위해서 자동으로 인터넷협의(IP)주소도 접수 될거에요.</p>
        <p>개인정보 및 안전 </p>
        <p>저희의 일상적인 업무 과정의 일환으로 개인 신상 정보를 아무나 혹은 아무 회사에 판매, 거래 또는 대여하지 않습니다.그러나 당신도 계정 정보를 잘 보관해야 하며, 타인에게 유출해서는 안 됩니다.</p>
        <p>어떻게 구독 취소를 하나요?</p>
        <p>메일 연락처 아랫부분 링크를 클릭하여 구독 취소할 수 있습니다. 혹은 당신의 사이트 유저 계정 페이지에서 구독 설정을 변경할 수 있습니다.</p>
        <p>저희에게 연락해주세요.</p>
        <p>본 개인정보 보호정책이나 귀하의 정보처리에 대한 문의, 의견 또는 요구사항이 있으시면 언제든지 연락주시기 바랍니다.</p>
        
      </div>
    `,
    shippingText: "해상 운송",
    shippingContent: `<div class="product__tab--content__step ">
      <h2 class="product__tab--content__title">해상 운송</h2>
      <p>총납품시간 = 처리시간 + 운송시간</p>
      <p>고객님은 최대 1회 배송비(반품 포함)만 지불하면 되며, 반품은 소비자에게 반품 비용을 청구하지 않습니다.</p>
      <p>처리 시간: 배송 전 품질 관리 검사 및 테스트를 수행하여 배송 전 제품의 품질을 보장합니다.보통 2-7일이 수요됩니다.그러나 이건 상품의 재고 상태에 영향을 받기도 합니다. 인기 상품의 경우 처리 시간은 업무일 기준 2-9일이 될 수 있습니다.</p>
      <p>우리는 해외 사이트, 국제 물류입니다.</p>
    </div>`,
    termsText: "약관",
    termsContent: `<div class="product__tab--content__step">
    <h2 class="product__tab--content__title">약관</h2>
    <strong class="h5">개술</strong>
    <p>당사는 귀하가 여기에 설명된 모든 약관, 조건, 정책 및 통지를 수락하는 전제하에 본 웹 사이트가 귀하(사용자)에게  모든 정보, 도구 및 서비스를 포함하여 본 웹 사이트를 제공합니다.</p>
    <p>웹사이트 방문 및/또는 저희로부터 물건을 구매함으로써, 귀하는 "서비스"에 참여하며, 이러한 추가 약관 및 정책을 포함하여 아래 약관 및/또는 하이퍼링크를 통해 이용할 수 있는 약관에 동의합니다.이러한 서비스 조항은 브라우저, 공급자, 고객, 사업자 및/또는 콘텐츠 기여자인 사용자를 포함하지만 이에 국한되지 않는 모든 웹 사이트의 사용자에게 적용됩니다.</p>
    <p>저희 웹사이트를 방문하시거나 이용하시기 전에 이 서비스 약관을 잘 읽어보시기 바랍니다.웹사이트의 어떤 부분을 방문하거나 사용함으로써, 귀하는 이러한 서비스 약관의 적용을 받는 것에 동의합니다.본 계약의 모든 약관에 동의하지 않는 경우, 웹 사이트를 방문하거나 서비스를 이용할 수 없습니다.이러한 서비스 약관이 요약으로 간주되는 경우 이러한 서비스 약관에 명시적으로 제한됩니다.</p>
    <p>현재 매장에 추가된 모든 새로운 기능 또는 도구도 서비스 약관을 준수해야 합니다.언제든지 이 페이지에서 최신 버전의 서비스 약관을 볼 수 있습니다.우리는 웹사이트에 업데이트 및 변경을 게시하여 이러한 서비스 약관의 모든 부분을 업데이트, 변경 또는 교체할 권리를 보유합니다.변경 사항을 이해하기 위해 이 페이지를 정기적으로 점검할 책임이 있습니다.변경 사항을 게시한 후 계속 사용하거나 웹 사이트를 방문하면 변경 사항을 수락한다는 것을 의미합니다.</p>
    <p>저희 매장은 Shopify Inc.에 위탁되어 있습니다.그들은 우리에게 온라인 전자상거래 플랫폼을 제공하여 우리가 당신에게 우리의 제품과 서비스를 판매할 수 있도록 합니다.</p>
    <ol>
      <li>
        <h5>1.온라인 스토어 약관</h5>
        <p>이러한 서비스 약관에 동의하는 것은 귀하가 최소한 귀하의 주 또는 거주 성의 성년 연령에 도달했음을 의미하며 귀하는 귀하의 미성년자 가족이 이 웹 사이트를 사용할 수 있도록 허용한다는 데 동의합니다.</p>
        <p>귀하는 불법 또는 허가되지 않은 목적으로 우리 제품을 사용할 수 없으며 서비스 사용 시 귀하의 관할 구역(저작권법 포함 및 이에 국한되지 않음)의 법률을 위반할 수 없습니다.웜이나 바이러스 또는 파괴적인 코드를 전파해서는 안 됩니다.</p>
        <p>어떠한 약관을 위반한 즉시 서비스가 종료됩니다.</p>
      </li>
      <li>
        <h5>2.일반조건</h5>
        <p>우리는 언제든지 어떤 이유로든 그 누구에게도 서비스를 거부할 권리를 보유합니다.</p>
        <p>귀하의 콘텐츠(신용카드 정보 제외)는 암호화되지 않은 상태로 전송되어 다양한 네트워크를 통해 전송될 수 있으며, (a) 각종 인터넷 전수를 통하여 (b)장치를 연결하는 기술 요구 사항에 부합하고 적응하도록 변경.신용카드 정보는 네트워크를 통해 전송되는 동안 항상 암호화됩니다.</p>
        <p>귀하는 당사의 명시적인 서면 허가 없이 서비스의 어떤 부분, 서비스의 이용, 서비스의 접근 또는 서비스를 제공하는 웹 사이트에 있는 어떠한 연락처도 복사, 복제, 판매, 재판매 또는 이용하지 않기로 동의합니다.</p>
        <p>이 계약에 사용된 테마는 편의상으로 지은거며 이러한 조항을 제한하거나 영향을 미치지 않습니다.</p>
      </li>
      <li>
        <h5>3.정보의 정확성, 완전성 및 적시성</h5>
        <p>만약 본 사이트에서 제공하는 정보가 정확하지 않거나 불완전하거나 최신이 아니라면, 저희는 일절 책임지지 않습니다.이 웹 사이트의 자료는 일반 참고용으로만 제공되며 주요, 보다 정확하고 완전하거나 시기적절한 정보 출처에 대한 상담 없이 의사 결정의 유일한 근거로 의존하거나 사용해서는 안 됩니다.이 웹사이트의 자료에 대한 모든 의존은 귀하 스스로 위험을 부담합니다.</p>
        <p>이 웹사이트에는 일부 과거 정보가 포함될 수 있습니다.과거 정보는 반드시 최신은 아니며, 참고하시기 바랍니다.당사는 언제든지 본 사이트의 내용을 수정할 수 있는 권리를 보유하지만, 당사 사이트에 있는 정보를 업데이트할 의무는 없습니다.귀하는 귀하가 우리 웹사이트의 변화를 모니터링할 책임이 있다는 것에 동의합니다.</p>
      </li>
      <li>
        <h5>4.서비스와 가격의 수정</h5>
        <p>우리 제품의 가격은 예고 없이 변경될 수 있습니다.</p>
        <p>우리는 예고 없이 언제든지 서비스(또는 그 어떤 부분이나 내용)를 수정하거나 종료할 권리를 보유합니다.</p>
        <p>본 서비스의 어떠한 변경, 가격 변동, 일시 정지 또는 중단에 대해서도 우리는 귀하 또는 제3자에게 어떠한 책임도 지지 않습니다.</p>
      </li>
      <li>
        <h5>5.제품 또는 서비스(해당되는 경우)</h5>
        <p>일부 제품 또는 서비스는 웹 사이트를 통해서만 온라인으로 제공될 수 있습니다.이러한 제품이나 서비스는 수량이 한정되어 있을 수 있으며, 반품 정책에 따라 반품 또는 교환만 가능합니다.</p>
        <p>매장에 나와 있는 제품의 색상과 이미지를 최대한 정확하게 보여주기 위해 최선을 다했습니다.컴퓨터 모니터에 표시되는 모든 색상이 정확하다는 보장은 없습니다.</p>
        <p>우리는 권리를 보유하지만 제품이나 서비스의 판매를 누구, 지리적 지역 또는 관할 구역으로 제한할 의무는 없습니다.우리는 구체적인 상황에 따라 이 권리를 행사할 수 있습니다.우리는 우리가 제공하는 어떠한 제품이나 서비스의 수량을 제한할 권리를 보유합니다.모든 제품 설명 또는 제품 가격은 예고 없이 언제든지 변경할 수 있으며, 우리 스스로 결정합니다.우리는 언제든지 모든 제품을 중지할 권리를 보유합니다.본 사이트에서 제공하는 모든 제품 또는 서비스에 대한 견적은 금지된 경우 무효입니다.</p>
        <p>구매 또는 획득한 제품, 서비스, 정보 또는 기타 재료의 품질이 기대치를 충족하거나 서비스의 오류가 수정될 것이라는 보장은 없습니다.</p>
      </li>
      <li>
        <h5>6.청구서 및 계좌정보의 정확성</h5>
        <p>우리는 당신이 우리에게 내린 어떤 주문도 거절할 권리를 보류합니다.우리는 1인당, 가구당 또는 주문 건당 구매 수량을 제한하거나 취소할 수 있습니다.이러한 제한에는 동일한 고객 계정, 동일한 신용카드 및/또는 동일한 청구서 및/또는 배달 주소를 사용하는 주문 또는 동일한 고객 계정 아래의 주문이 포함될 수 있습니다.주문을 변경하거나 취소하면 주문 시 알려주신 이메일 및/또는 청구서 주소/전화번호로 연락드리겠습니다.우리는 우리의 판단에 따라 딜러점, 리셀러 또는 유통업체가 발주한 것으로 보이는 주문을 제한하거나 금지할 권리를 보유합니다.</p>
        <p>귀하는 저희 매장에서 이루어지는 모든 구매에 대해 최신, 완전하고 정확한 구매 및 계좌 정보를 제공하는데 동의합니다.귀하의 이메일 주소와 신용카드 번호, 만료 날짜를 포함한 계정 및 기타 정보를 적시에 업데이트하여 거래를 완료하고 필요할 때 연락드릴 수 있도록 동의합니다.</p>
        <p>더 자세한 정보는, 우리의 반품 정책을 확인해 주십시오.</p>
      </li>
      <li>
        <h5>7.옵션공구</h5>
        <p>모니터링하거나 제어하거나 입력하지 않는 타사 도구에 대한 액세스 권한을 제공할 수 있습니다.</p>
        <p>귀하는 이러한 도구에 대한 어떠한 보증, 진술 또는 조건이나 배서도 없이 '있는 그대로' 및 '사용 가능한' 액세스를 제공한다는 것을 인정하고 동의합니다.귀하의 선택적 제3자 도구 사용으로 인해 발생하거나 이와 관련된 책임은 일절 책임지지 않습니다.</p>
        <p>웹사이트를 통해 제공되는 선택적 도구의 사용은 전적으로 귀하의 위험 부담과 자체 결정이며, 관련 제3자 제공자의 도구 제공 약관에 익숙하고 승인되었는지 확인해야 합니다.</p>
        <p>향후에는 웹사이트를 통해 새로운 서비스 및/또는 기능(새로운 도구 및 자원의 게시 포함)을 제공할 수도 있습니다.이러한 새로운 기능 및/또는 서비스도 이러한 서비스 조항을 준수해야 합니다.</p>
      </li>
      <li>
        <h5>8.제3자 링크</h5>
        <p>저희 서비스를 통해 제공되는 특정 콘텐츠, 제품 및 서비스에는 제3자의 자료가 포함될 수 있습니다.</p>
        <p>본 사이트의 제3자 링크는 귀하를 우리와 무관한 제3자 사이트로 안내할 수 있습니다.우리는 내용이나 정확성을 확인하거나 평가할 책임이 없으며 제3자 자료나 웹사이트 또는 제3자의 기타 자료, 제품 또는 서비스에 대한 책임이나 의무를 지지 않을 것을 보장하지 않습니다.</p>
        <p>우리는 상품, 서비스, 자원, 콘텐츠 또는 제3자 웹사이트와 관련된 기타 거래의 구매 또는 사용과 관련된 어떠한 손상이나 손해에 대해서도 책임을 지지 않습니다.제3자의 정책과 관행을 잘 읽어보시고 어떤 거래든 진행하기 전에 반드시 이해하시기 바랍니다.제3자 제품에 대한 불만, 클레임, 의심 또는 질문은 제3자에게 직접 제출해야 합니다.</p>
      </li>
      <li>
        <h5>9.사용자 리뷰, 피드백 및 기타 의견</h5>
        <p>당사의 요청에 따라 귀하가 특정 제출서류(예: 출품작)를 발송했거나, 요청하지 않은 경우 귀하가 온라인, 이메일, 우편 또는 기타 자료(통칭 '리뷰')를 통해 언제든지 제한 없이 편집, 복사, 배포, 번역 및 기타 매체에 전달한 리뷰를 사용할 수 있다는 데 동의합니다.우리는 (1) 댓글에 대해 비밀을 지킬 의무가 없으며, (2) 댓글에 대해 보상할 의무없으며 (3)댓글에 대응할 필요없습니다.</p>
        <p>불법, 모욕, 협박, 비방, 비방, 음담패설 또는 그 밖에 어느 한쪽의 지적재산권이나 본 서비스 약관에 위배되는 것으로 판단되는 내용을 감시하고 편집하거나 삭제할 의무는 없습니다.</p>
        <p>귀하의 댓글이 저작권, 상표, 프라이버시, 인격 또는 기타 개인 또는 소유권을 포함한 제3자의 어떠한 권리도 침해하지 않는다는 데 동의합니다.귀하의 리뷰에는 비방 또는 기타 불법, 욕설 또는 외설적인 자료가 포함되어 있지 않거나 서비스 또는 관련 웹 사이트의 운영에 어떠한 방식으로든 영향을 미칠 수 있는 컴퓨터 바이러스 또는 기타 악성 소프트웨어가 포함되어 있지 않다는 데 동의합니다.당신은 허위 이메일 주소를 사용하거나, 본인이 아닌 척하거나, 다른 방식으로 우리 또는 제3자의 논평 출처를 오도해서는 안 됩니다.귀하는 귀하의 논평과 정확성에 대한 모든 책임을 집니다.귀하 또는 제3자가 게시한 코멘트에 대해서는 어떠한 책임도 지지 않습니다.</p>
      </li>
      <li>
        <h5>10.개인정보</h5>
        <p>매장을 통해 제출하신 개인정보는 저희 프라이버시 정책의 적용을 받습니다.개인 정보 보호 정책 보기</p>
      </li>
      <li>
        <h5>11.오류, 부정확, 누락</h5>
        <p>때때로 저희 웹사이트나 서비스에 있는 정보에는 제품 설명, 가격 책정, 판촉, 할인, 제품 배송비, 운송 시간 및 가용성과 관련된 인쇄 오류, 부정확성 또는 누락이 포함될 수 있습니다.서비스 또는 관련 웹사이트의 정보가 정확하지 않은 경우, 우리는 예고 없이(주문서를 제출한 후 포함) 어떠한 오류, 부정확함 또는 누락도 수정하거나 정보를 변경하거나 갱신하거나 주문을 취소할 수 있는 권리를 보유합니다.</p>
        <p>법적 요구 사항을 제외하고 가격 책정 정보를 포함하여 서비스 또는 관련 웹 사이트의 정보를 업데이트, 수정 또는 명확히 할 의무가 없습니다.지정된 업데이트 또는 갱신 날짜가 서비스 또는 관련 웹 사이트에 적용되지 않은 경우 서비스 또는 관련 웹 사이트의 모든 정보가 수정 또는 업데이트되었음을 나타내는 것으로 간주됩니다.</p>
      </li>
      <li>
        <h5>12.사용금지</h5>
        <p>서비스 약관에 규정된 기타 금지령을 제외하고, 귀하는 본 사이트 또는 그 내용을 사용할 수 없습니다. (a) 어떠한 불법적인 목적을 위해 사용되며, (b) 타인을 유인하여 어떠한 불법 행위를 하거나 참여시키는 것, (c) 어떠한 국제, 연방, 성 또는 주의 법규, 법률 또는 지방 조례를 위반하는 것, (d) 우리의 지적 재산권 또는 타인의 지적 재산권을 침해하거나 위반하는 것, (e) 성별에 따라 성지적 지향성, 종교, 인종, 인종, 연령 및 국적 또는 장애에 따라 괴롭힘, 욕설·모욕·상해·비방설·비방위협박 또는 차별을 하는 것.(f) 가짜정보를 제공 (g)바이러스 또는 악성 코드를 전파 (h) 타인의 정보를 수집 (i) 스팸 메일.(j) 외설적이거나 부도덕한 목적, (k) 서비스 또는 관련 사이트, 기타 사이트 또는 인터넷의 보안 기능을 방해하거나 회피합니다.금지된 서비스를 위반하거나 관련 사이트를 종료할 수 있는 권리를 보유합니다.(j) 외설적이거나 부도덕한 목적, (k) 서비스 또는 관련 사이트, 기타 사이트 또는 인터넷의 보안 기능을 방해하거나 회피합니다.금지된 서비스를 위반하거나 관련 사이트를 종료할 수 있는 권리를 보유합니다.</p>
      </li>
      <li>
        <h5>13.면책성명</h5>
        <p>저희는 귀하가 저희 서비스에 대한 이용을 중단, 적시, 안전 또는 오류가 없도록 보장하거나 진술 또는 보증하지 않습니다.</p>
        <p>서비스 이용으로 얻을 수 있는 결과가 정확하거나 신뢰할 수 있다는 보장은 없습니다.</p>
        <p>예고 없이 수시로 서비스를 무기한 삭제하거나 언제든지 취소할 수 있다는 것에 동의하셨습니다.</p>
        <p>귀하는 서비스를 이용하거나 이용할 수 없는 위험을 스스로 부담하는 것에 대해 명확히 동의합니다.서비스 및 서비스를 통해 귀하에게 인도되는 모든 제품 및 서비스는 상품성, 시장성, 적합성, 특정 용도의 적용성, 내구성, 소유권 및 비침해에 대한 묵시적 보증 또는 조건을 포함하여 명시적 또는 명시적 형태의 진술, 보증 또는 조건 없이 "사용 가능"하게 제공됩니다.</p>
        <p>어떠한 경우에도 우리의 이사, 임원, 직원, 계열사, 대리인, 도급업자, 인턴, 공급자, 서비스 제공자 또는 면허인은 어떠한 상해, 손실, 클레임 또는 어떠한 직간접적·부차적·징벌적·특수적 또는 결과적인 손해에 대하여 어떠한 유형의 손해에 대하여 어떠한 종류의 책임도 지지 않습니다. 어떤 서비스를 이용하거나 서비스를 이용하여 얻은 제품이나 어떤 방식으로든 당신의 서비스나 어떤 제품과 관련된 다른 클레임도 포함하되 이에 국한되지 않습니다. 어떤 내용의 오류나 누락이나 어떠한 손실이나 서비스 이용 또는 게시·전송된 모든 종류의 손해나 그 밖의 방법으로든 그 가능성이 이미 알려졌더라도.</p>
        <p>일부 주 또는 관할권에서는 간접 또는 부수적인 손해에 대한 책임을 배제하거나 제한하는 것을 허용하지 않기 때문에 이러한 주 또는 관할권에서는 우리의 책임이 법률에서 허용하는 최대 범위로 제한되어야 합니다.</p>
      </li>
      <li>
        <h5>14.배상</h5>
        <p>귀하는 귀하가 이러한 서비스 약관을 위반하거나 합병된 문서를 인용하거나 법률 또는 제3자의 권리를 위반하여 발생하는 합리적인 제3자의 변호사 비용을 포함하여 귀사와 당사의 모회사, 자회사, 종속회사, 협력업체, 계약자, 라이센스 제공자, 서비스 제공업체, 하청업체 및 인턴 및 종업원에 대해 보상하고 변호하며 청구 또는 청구로부터 보호하기로 동의합니다.</p>
      </li>
      <li>
        <h5>15.분할성</h5>
        <p>본 서비스 약관의 조항이 불법, 무효 또는 집행 불가로 판명된 경우, 해당 조항은 여전히 적용 법률이 허용하는 최대 범위 내에서 집행될 수 있어야 하며, 집행 불가 부분은 본 조항과 분리된 서비스로 간주되어야 하며 이러한 결정은 다른 나머지 조항의 유효성과 실행 가능성에 영향을 미치지 않아야 합니다.</p>
      </li>
      <li>
        <h5>16.종료</h5>
        <p>모든 목적에 대해 양 당사자의 의무와 책임은 종료일 이전에 본 계약이 종료된 후에도 계속 유효해야 합니다.</p>
        <p>이러한 서비스 약관은 귀하 또는 우리가 종료할 때까지 유효합니다.저희 서비스를 더 이상 이용하지 않으시거나 사이트 이용을 중지하시라고 언제든지 알려주시면 해당 서비스 약관을 해지하실 수 있습니다.</p>
        <p>만약 우리가 일방적으로 당신이 본 서비스 약관의 어떤 조항이나 규정을 준수하지 못했다고 판단하거나 의심한다면, 우리는 또한 언제든지 본 계약을 종료할 수 있습니다. 예고 없이, 당신은 여전히 모든 만기 대금에 대해 책임을 지고 종료 날짜를 포함할 것입니다. 및/또는 이로 인해 귀하가 우리의 서비스(또는 그 어떤 부분)에 접근하는 것을 거부할 수도 있습니다.</p>
      </li>
      <li>
        <h5>17.완전한 합의</h5>
        <p>당사가 본 서비스 약관의 권리 또는 규정을 행사하거나 이행할 수 없는 것은 해당 권리 또는 규정의 포기를 구성하지 않습니다.</p>
        <p>이러한 서비스 약관 및 본 웹 사이트에 게시되거나 서비스와 관련된 모든 정책 또는 운영 규칙은 귀하와 저희 사이의 완전한 협의와 양해를 구성하고 귀하의 서비스 이용을 제약하며 이전이나 같은 기간의 협의, 통신과 건의를 대체합니다. 귀하와 저희(서비스 약관의 모든 이전 버전을 포함하되 이에 국한되지 않음).
        </p>
        <p>이 서비스 약관의 해석에 다른 의미가 있는 경우 작성자에게 불리한 해석을 해서는 안 됩니다.</p>
      </li>
      <li>
        <h5>18.서비스 약관의 변경</h5>
        <p>언제든지 이 페이지에서 최신 버전의 서비스 약관을 볼 수 있습니다.</p>
        <p>당사 웹 사이트에 업데이트 및 변경을 게시하여 이러한 서비스 약관의 모든 부분을 업데이트, 변경 또는 교체하기로 결정할 수 있는 권리를 보유합니다.변경 사항을 이해하기 위해 정기적으로 저희 웹사이트를 볼 책임이 있습니다.이러한 서비스 약관에 대한 변경 사항을 발표한 후, 당신이 우리의 웹사이트나 서비스에 계속 접속하는 것은 당신이 이러한 변경을 수락한다는 것을 의미합니다.</p>
      </li>
      <li>
        <h5>19.적용법률</h5>
        <p>이러한 서비스 약관과 귀하에게 서비스를 제공하기 위한 별도의 계약은 현지 법률의 관할 하에 있으며 현지 법률에 따라 해석됩니다.</p>
      </li>
      <!-- JieHeng网站的 -->
      <li><h5>20.해상 운송</h5>
      <p>총납품시간 = 처리시간 + 운송시간</p>
      <p>객님은 최대 1회 배송비(반품 포함)만 지불하면 되며, 반품은 소비자에게 반품 비용을 청구하지 않습니다.</p>
      <p>처리 시간: 배송 전 품질 관리 검사 및 테스트를 수행하여 배송 전 제품의 품질을 보장합니다.보통 2-7일이 수요됩니다.그러나 이건 상품의 재고 상태에 영향을 받기도 합니다. 인기 상품의 경우 처리 시간은 업무일 기준 2-9일이 될 수 있습니다.</p>
      <p>우리는 해외 사이트, 국제 물류입니다.</p>
    </li>
    </ol>
  </div>`,
  },
  // productList: [
  //   {
  //     id: 1,
  //     imgUrl: "pro1-1.jpg",
  //     title: "SASAVIN蛋白棒",
  //     singlePrice: 70254,
  //     bigProduct:['pro1-2.png','pro1-3.png']
  //   },
  //   {
  //     id: 2,
  //     imgUrl: "pro2-1.jpg",
  //     title: "朵匠、优姿轻解素、益生元多肽片压片糖果",
  //     singlePrice: 95801,
  //     bigProduct:['pro2-2.jpg','pro2-3.jpg']

  //   },
  //   {
  //     id: 3,
  //     imgUrl: "pro3-1.jpg",
  //     title: "亨德仁源堂油切分解素双菇多肽粉固体饮料",
  //     singlePrice: 61313,
  //     bigProduct:['pro3-2.jpg','pro3-3.jpg']

  //   },
  //   {
  //     id: 4,
  //     imgUrl: "pro4-1.jpg",
  //     title: "极魅曲然堂、低脂高纤型代餐营养粉",
  //     singlePrice: 88137,
  //     bigProduct:['pro4-2.jpg','pro4-3.jpg']

  //   },
  //   {
  //     id: 5,
  //     imgUrl: "pro5-1.jpg",
  //     title: "蓝莓复合益生元固体饮料",
  //     singlePrice: 98356,
  //     bigProduct:['pro5-2.jpg','pro5-3.jpg']

  //   },
  //   {
  //     id: 6,
  //     imgUrl: "pro6-1.jpg",
  //     title: "诺丽果低聚果糖压片",
  //     singlePrice: 95801,
  //     bigProduct:['pro6-2.png','pro6-3.png']

  //   },
  //   {
  //     id: 7,
  //     imgUrl: "pro7-1.jpg",
  //     title: "奇亚籽固体饮料",
  //     singlePrice: 95801,
  //     bigProduct:['pro7-2.jpg','pro7-3.jpg']

  //   },
  //   {
  //     id: 8,
  //     imgUrl: "pro8-1.jpg",
  //     title: "轻姿溶解素",
  //     singlePrice: 192879,
  //     bigProduct:['pro8-2.jpg','pro8-3.jpg']

  //   },
  //   {
  //     id: 9,
  //     imgUrl: "pro9-1.jpg",
  //     title: "神奇粉末，固体饮料",
  //     singlePrice: 58758,
  //     bigProduct:['pro9-2.jpg','pro9-3.png']

  //   },
  //   {
  //     id: 10,
  //     imgUrl: "pro10-1.jpg",
  //     title: "神奇粉末益生菌果蔬植物酵素粉",
  //     singlePrice: 95801,
  //     bigProduct:['pro10-2.jpg','pro10-3.png']

  //   },
  //   {
  //     id: 11,
  //     imgUrl: "pro11-1.jpg",
  //     title: "新活力因子",
  //     singlePrice: 66422,
  //     bigProduct:['pro11-2.png','pro11-3.jpg','pro11-4.jpg']

  //   },
  //   {
  //     id: 12,
  //     imgUrl: "pro12-1.jpg",
  //     title: "新--芊润易简玫奇亚籽固体饮料",
  //     singlePrice: 95801,
  //     bigProduct:['pro12-2.png','pro12-3.png']

  //   },
  //   {
  //     id: 13,
  //     imgUrl: "pro13-1.jpg",
  //     title: "伊美源、轻轻果冻果味型果冻",
  //     singlePrice: 95801,
  //     bigProduct:['pro13-2.jpg','pro13-3.jpg']

  //   },
  //   {
  //     id: 14,
  //     imgUrl: "pro14-1.jpg",
  //     title: "植物三调茶",
  //     singlePrice: 95801,
  //     bigProduct:['pro14-2.jpg','pro14-3.png','pro14-4.png']

  //   },
  //   {
  //     id: 15,
  //     imgUrl: "pro15-1_ko.png",
  //     title: "가격차를 보충하다",
  //     singlePrice: 1000
  //   },
  // ],
  productList: [],

  cartList: [],
  retail: {
    id: 15,
    imgUrl: "pro15-1_ko.png",
    title: "가격차를 보충하다",
    singlePrice: 1,
    isRetail: true,
  },
};
